export default {
  creatKey ({commit},data) {
    commit('PER_KEY',data);
  },
  getGinfo ({commit},data) {
    commit('GOOD_INFO',data)
  }
}
